// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Folder_wrapper__1PP6n","errorWrapper":"Folder_errorWrapper__1hwA2"};